import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Author Types',
  basePath: '/author-types',
  columns: [
    { key: 'name', label: 'Author Type', sortable: true },
  ],
  fields: [
    { key: 'name', label: 'Author type name', type: 'text', required: true },
  ],
  defaultSort: { field: 'name', dir: 'asc' },
});
